import $ from "jquery";
/* eslint-disable */
import slick from "slick-carousel";
/* eslint-enable */

const elements = {
  $carousels: $(".c-video-related"),
};

const matchMobileWidth = window.matchMedia("(max-width: 61.25em)");

function toggleCarousel(match, carousel) {
  match ? setCarousel(carousel) : removeCarousel(carousel);
}

function setCarousel(carousel) {
  if (carousel.el.hasClass("slick-initialized")) return;
    carousel.el.slick({
      dots: carousel.dots,
      speed: 800,
      slidesToShow: carousel.mobileSlidesToShow,
      slidesToScroll: carousel.mobileSlidesToScroll,
      infinite: false,
      arrows: false,
      rows: carousel.mobileRows,
      slidesPerRow: carousel.mobileSlidesPerRow,
    });
  if (carousel.arrows) {
    carousel.next.show();
    carousel.prev.show();
  }
}

function removeCarousel(carousel) {
  if (!carousel.el.hasClass("slick-initialized")) return;
  carousel.el.slick("unslick");
}

function init() {
  if (elements.$carousels.length > 0) {
    elements.$carousels.each((index, el) => {
      const parent = $(el).parent();
      const carousel = {
        el: $(el),
        slides: parent.find(".c-video-related__wrapper"),
        next: parent.find(".js-card-carousel-next"),
        prev: parent.find(".js-card-carousel-prev"),
        dots: parent.data("dots") || false,
        arrows: parent.data("arrows") || false,
        showDesktop: parent.data("showDesktop") || false,
        mobileSlidesToShow: parent.data("mobileSlidesToShow") || 1.3,
        mobileSlidesToScroll: parent.data("mobileSlidesToScroll") || 1,
      };

      if (carousel.el && carousel.slides.length > 0) {
        if (carousel.slides.length < 1) return carousel.el.parent().show();

        carousel.prev.on("click", () => {
          carousel.el.slick("slickPrev");
        });

        carousel.next.on("click", () => {
          carousel.el.slick("slickNext");
        });

        if (!carousel.showDesktop) {
          parent.addClass("is-mobile-only");
          matchMobileWidth.addEventListener("change", (e) => {
            toggleCarousel(e.matches, carousel);
          });
          toggleCarousel(matchMobileWidth.matches, carousel);
        } else {
          setCarousel(carousel);
        }
      }
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/video/video-carousel.js